var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 133,
    viewBox: "0 0 157 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V133H157V0H0Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5 81H60.5C59.25 81 58.1875 80.5625 57.3125 79.6875C56.4375 78.8125 56 77.75 56 76.5V49.5C56 48.25 56.4375 47.1875 57.3125 46.3125C58.1875 45.4375 59.25 45 60.5 45H99.5C100.75 45 101.812 45.4375 102.688 46.3125C103.562 47.1875 104 48.25 104 49.5V76.5C104 77.75 103.562 78.8125 102.688 79.6875C101.812 80.5625 100.75 81 99.5 81ZM70.1562 51.8438C69.1562 50.7812 67.9375 50.25 66.5 50.25C65.0625 50.25 63.8125 50.7812 62.75 51.8438C61.75 52.8438 61.25 54.0625 61.25 55.5C61.25 56.9375 61.75 58.1875 62.75 59.25C63.8125 60.25 65.0625 60.75 66.5 60.75C67.9375 60.75 69.1562 60.25 70.1562 59.25C71.2188 58.1875 71.75 56.9375 71.75 55.5C71.75 54.0625 71.2188 52.8438 70.1562 51.8438ZM62 75H98V64.5L89.75 56.25C89.25 55.75 88.75 55.75 88.25 56.25L75.5 69L70.25 63.75C69.75 63.25 69.25 63.25 68.75 63.75L62 70.5V75Z",
    fill: "#DEDEDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.a72a44917d1982a3a31f21a259995012.svg";
export { ForwardRef as ReactComponent };